import { render, staticRenderFns } from "./AuthorityRelation.vue?vue&type=template&id=7be21aea&scoped=true&"
import script from "./AuthorityRelation.vue?vue&type=script&lang=js&"
export * from "./AuthorityRelation.vue?vue&type=script&lang=js&"
import style0 from "./AuthorityRelation.vue?vue&type=style&index=0&id=7be21aea&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7be21aea",
  null
  
)

export default component.exports